import template from './rw-list.html';

export default class RwListComponent {
  constructor() {
    this.template = template;
    this.transclude = true;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-list/rw-list-component.js